// extracted by mini-css-extract-plugin
module.exports = {"preview":"ChannelPreview_preview__3uazg"};